module.exports = __webpack_public_path__ + "img/5.f99ad942.png";